/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";

import {
  ILoadingMethods,
  LoadingService,
  IStaticPageContentMethods,
  StaticPageContentService,
  IRowDetailMethods,
  RowDetailService
} from "./components";

export type RowDetailPageAgent = 
  IStaticPageContentMethods &
  ILoadingMethods & IRowDetailMethods;

const getPlugins = () => {
  return [
    new LoadingService(),
    new StaticPageContentService(),
    new RowDetailService()
  ];
};

export const getAgent = () => {
  return createAgent<RowDetailPageAgent>({
    plugins: getPlugins(),
  });
};
